module.exports = __webpack_public_path__ + "img/A3.4e1ab066.svg";